import React, { useState, useEffect } from "react";
import "./index.m.css";

const SuccessIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
    <path
      d="M9.46 16.06L17.215 8.305L15.675 6.765L9.46 12.98L6.325 9.845L4.785 11.385L9.46 16.06ZM11 22C9.47833 22 8.04833 21.7113 6.71 21.1338C5.37167 20.5562 4.2075 19.7725 3.2175 18.7825C2.2275 17.7925 1.44375 16.6283 0.86625 15.29C0.28875 13.9517 0 12.5217 0 11C0 9.47833 0.28875 8.04833 0.86625 6.71C1.44375 5.37167 2.2275 4.2075 3.2175 3.2175C4.2075 2.2275 5.37167 1.44375 6.71 0.86625C8.04833 0.28875 9.47833 0 11 0C12.5217 0 13.9517 0.28875 15.29 0.86625C16.6283 1.44375 17.7925 2.2275 18.7825 3.2175C19.7725 4.2075 20.5562 5.37167 21.1338 6.71C21.7113 8.04833 22 9.47833 22 11C22 12.5217 21.7113 13.9517 21.1338 15.29C20.5562 16.6283 19.7725 17.7925 18.7825 18.7825C17.7925 19.7725 16.6283 20.5562 15.29 21.1338C13.9517 21.7113 12.5217 22 11 22Z"
      fill="#5FCB5B"
    />
  </svg>
);

const FailureIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
    <path
      d="M12.3194 16.9194C12.5398 16.699 12.65 16.4258 12.65 16.1C12.65 15.7742 12.5398 15.501 12.3194 15.2806C12.099 15.0602 11.8258 14.95 11.5 14.95C11.1742 14.95 10.901 15.0602 10.6806 15.2806C10.4602 15.501 10.35 15.7742 10.35 16.1C10.35 16.4258 10.4602 16.699 10.6806 16.9194C10.901 17.1398 11.1742 17.25 11.5 17.25C11.8258 17.25 12.099 17.1398 12.3194 16.9194ZM10.35 12.65H12.65V5.75H10.35V12.65ZM11.5 23C9.90917 23 8.41417 22.6981 7.015 22.0944C5.61583 21.4906 4.39875 20.6712 3.36375 19.6362C2.32875 18.6012 1.50938 17.3842 0.905625 15.985C0.301875 14.5858 0 13.0908 0 11.5C0 9.90917 0.301875 8.41417 0.905625 7.015C1.50938 5.61583 2.32875 4.39875 3.36375 3.36375C4.39875 2.32875 5.61583 1.50938 7.015 0.905625C8.41417 0.301875 9.90917 0 11.5 0C13.0908 0 14.5858 0.301875 15.985 0.905625C17.3842 1.50938 18.6012 2.32875 19.6362 3.36375C20.6712 4.39875 21.4906 5.61583 22.0944 7.015C22.6981 8.41417 23 9.90917 23 11.5C23 13.0908 22.6981 14.5858 22.0944 15.985C21.4906 17.3842 20.6712 18.6012 19.6362 19.6362C18.6012 20.6712 17.3842 21.4906 15.985 22.0944C14.5858 22.6981 13.0908 23 11.5 23Z"
      fill="#EB6B6B"
    />
  </svg>
);

const InfoIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
    <path
      d="M9.9 16.5H12.1V9.9H9.9V16.5ZM11.7838 7.38375C11.9946 7.17292 12.1 6.91167 12.1 6.6C12.1 6.28833 11.9946 6.02708 11.7838 5.81625C11.5729 5.60542 11.3117 5.5 11 5.5C10.6883 5.5 10.4271 5.60542 10.2163 5.81625C10.0054 6.02708 9.9 6.28833 9.9 6.6C9.9 6.91167 10.0054 7.17292 10.2163 7.38375C10.4271 7.59458 10.6883 7.7 11 7.7C11.3117 7.7 11.5729 7.59458 11.7838 7.38375ZM11 22C9.47833 22 8.04833 21.7113 6.71 21.1338C5.37167 20.5563 4.2075 19.7725 3.2175 18.7825C2.2275 17.7925 1.44375 16.6283 0.86625 15.29C0.28875 13.9517 0 12.5217 0 11C0 9.47833 0.28875 8.04833 0.86625 6.71C1.44375 5.37167 2.2275 4.2075 3.2175 3.2175C4.2075 2.2275 5.37167 1.44375 6.71 0.86625C8.04833 0.28875 9.47833 0 11 0C12.5217 0 13.9517 0.28875 15.29 0.86625C16.6283 1.44375 17.7925 2.2275 18.7825 3.2175C19.7725 4.2075 20.5563 5.37167 21.1338 6.71C21.7113 8.04833 22 9.47833 22 11C22 12.5217 21.7113 13.9517 21.1338 15.29C20.5563 16.6283 19.7725 17.7925 18.7825 18.7825C17.7925 19.7725 16.6283 20.5563 15.29 21.1338C13.9517 21.7113 12.5217 22 11 22Z"
      fill="#63B5E2"
    />
  </svg>
);

const CloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path
      d="M1.63333 11.6375L0 10.0042L4.2 5.80417L0 1.63333L1.63333 0L5.83333 4.2L10.0042 0L11.6375 1.63333L7.4375 5.80417L11.6375 10.0042L10.0042 11.6375L5.83333 7.4375L1.63333 11.6375Z"
      fill="#444444"
    />
  </svg>
);

export const Snackbar = () => {
  const [type, setType] = useState(null); // 'success', 'failure', 'info'
  const [message, setMessage] = useState("");
  const [bottomOffset, setBottomOffset] = useState("52px");
  const [topOffset, setTopOffset] = useState("110px");

  useEffect(() => {
    if (type) {
      const timer = setTimeout(() => {
        setType(null);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [type, message]);

  useEffect(() => {
    // Only run on client side
    if (typeof window !== "undefined") {
      const checkUrl = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const q = urlParams.get("q");
        if (q === "successsnack" || q === "sucesssnack") {
          setType("success");
          setMessage("Success Toast Message");
        } else if (q === "failuresnack") {
          setType("failure");
          setMessage("Failure Toast Message");
        } else if (q === "infosnack") {
          setType("info");
          setMessage("Information Toast Message");
        } else if (urlParams.get("showSnackbar") === "activeSub") {
          setType("info");
          setMessage("You already have an active Subscription!");
          
          urlParams.delete("showSnackbar");
          const newUrl = window.location.pathname + (urlParams.toString() ? `?${urlParams.toString()}` : "") + window.location.hash;
          window.history.replaceState(null, "", newUrl);
        } else {
          // Do not clear it here blindly because CustomEvent might have set it.
          // Wait, if URL changes to ?q=somethingelse, we might want to close the URL-based snackbar.
          // To keep it safe, if there's an event-based snackbar we shouldn't clear it. Let's rely on a timeout to clear the snackbar later, or keep the existing logic:
          // setType(null);
        }
      };

      checkUrl();

      // Custom Event listener for explicit snackbar dispatching
      const handleCustomSnackbar = (event) => {
        if (event?.detail) {
          setType(event.detail.type);
          setMessage(event.detail.message);
        }
      };

      window.addEventListener("show-snackbar", handleCustomSnackbar);

      // Listen to SPA route changes
      const originalPushState = window.history.pushState;
      window.history.pushState = function (...args) {
        originalPushState.apply(this, args);
        checkUrl();
      };

      const originalReplaceState = window.history.replaceState;
      window.history.replaceState = function (...args) {
        originalReplaceState.apply(this, args);
        checkUrl();
      };
      window.addEventListener("popstate", checkUrl);

      if (window.innerWidth <= 1024) {
        const calculateOffset = () => {
          let totalBottomOffset = 0;

          const stickyNav = document.getElementById("sticky-bottom-navbar");
          if (stickyNav) {
            const isHidden = Array.from(stickyNav.classList).some((c) => c.includes("hidden"));
            if (!isHidden) {
              totalBottomOffset += stickyNav.offsetHeight;
            }
          }

          const banner = document.querySelector("#sticky-banner-id .banner");
          if (banner) {
            totalBottomOffset += banner.offsetHeight;
          }

          setBottomOffset(totalBottomOffset + "px");
        };

        calculateOffset();
        const observer = new MutationObserver(calculateOffset);

        const stickyNav = document.getElementById("sticky-bottom-navbar");
        if (stickyNav) {
          observer.observe(stickyNav, { attributes: true, attributeFilter: ["class"] });
        }

        const bannerWrapper = document.getElementById("sticky-banner-id");
        if (bannerWrapper) {
          observer.observe(bannerWrapper, { childList: true, subtree: true });
        }

        return () => {
          observer.disconnect();
          window.removeEventListener("popstate", checkUrl);
          window.removeEventListener("show-snackbar", handleCustomSnackbar);
          window.history.pushState = originalPushState;
          window.history.replaceState = originalReplaceState;
        };
      } else {
        const calculateDesktopOffset = () => {
          let totalHeight = 0;

          const primaryHeaders = document.querySelectorAll(
            "header, #header, [class*='header-main'], [class*='headerTop']"
          );
          let primaryHeader = null;
          for (let i = 0; i < primaryHeaders.length; i++) {
            if (primaryHeaders[i].offsetHeight > 0) {
              primaryHeader = primaryHeaders[i];
              totalHeight += primaryHeader.offsetHeight;
              break;
            }
          }

          const secondaryHeaders = document.querySelectorAll("[class*='header-secondary']");
          for (let i = 0; i < secondaryHeaders.length; i++) {
            if (
              secondaryHeaders[i].offsetHeight > 0 &&
              (!primaryHeader || !primaryHeader.contains(secondaryHeaders[i]))
            ) {
              totalHeight += secondaryHeaders[i].offsetHeight;
              break;
            }
          }

          if (totalHeight > 0) {
            setTopOffset(totalHeight + 10 + "px");
          } else {
            setTopOffset("110px");
          }
        };

        calculateDesktopOffset();
        const observer = new MutationObserver(calculateDesktopOffset);
        const headersNode = document.querySelectorAll(
          "header, #header, [class*='header-main'], [class*='header-secondary'], [class*='headerTop']"
        );
        headersNode.forEach((node) => {
          if (node) observer.observe(node, { childList: true, subtree: true, attributes: true });
        });

        return () => {
          observer.disconnect();
          window.removeEventListener("popstate", checkUrl);
          window.removeEventListener("show-snackbar", handleCustomSnackbar);
          window.history.pushState = originalPushState;
          window.history.replaceState = originalReplaceState;
        };
      }
    }
  }, []);

  if (!type) return null;

  return (
    <div styleName="container" style={{ "--bottom-offset": bottomOffset, "--top-offset": topOffset }}>
      <div styleName={`snackbar ${type}`}>
        {type === "success" && <SuccessIcon />}
        {type === "failure" && <FailureIcon />}
        {type === "info" && <InfoIcon />}

        <span styleName="message">{message}</span>
        <button styleName="closeBtn" onClick={() => setType(null)}>
          <CloseIcon />
        </button>
      </div>
    </div>
  );
};
